import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow, Checkbox } from '@mui/material';
import { withRights } from 'providers/RightsConsumer';
import WrappedLinearProgress from 'components/common/WrappedLinearProgress';

export const OfferPartnerIncomeTypeComponent = ({ onChange, incomeTypes, loading, rights }) => {
  const { t } = useTranslation();

  const handleOnChange = incomeType => event => {
    onChange(incomeType, event.target.checked);
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            <strong>{t('OfferEdit.Client.IncomeType.Select')}</strong>
          </TableCell>
          <TableCell>
            <strong>{t('OfferEdit.Client.IncomeType.Name')}</strong>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {incomeTypes.map((incomeType, idx) => {
          return (
            <TableRow key={incomeType.incomeTypeId}>
              {loading[incomeType.incomeTypeId] === true ? (
                <>
                  <TableCell>
                    {' '}
                    <Checkbox
                      id={'offerPartnerIncomeTypeCard_' + idx + '_isSelected'}
                      checked={incomeType.selected}
                      onChange={handleOnChange(incomeType)}
                      value='1'
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell colSpan={1}>
                    <WrappedLinearProgress />
                  </TableCell>
                </>
              ) : (
                <>
                  <TableCell>
                    {' '}
                    <Checkbox
                      id={'offerPartnerIncomeTypeCard_' + idx + '_isSelected'}
                      checked={incomeType.selected}
                      onChange={handleOnChange(incomeType)}
                      value='1'
                      disabled={rights.readOnlyFull || !rights.clientIncomeSourcesWrite}
                    />
                  </TableCell>
                  <TableCell id={'offerPartnerIncomeTypeCard_' + idx + '_incomeTypeName'}>{incomeType.name}</TableCell>
                </>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

OfferPartnerIncomeTypeComponent.propTypes = {
  incomeTypes: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.object.isRequired,
  rights: PropTypes.object.isRequired
};

export default withRights(OfferPartnerIncomeTypeComponent);
